import get from 'lodash/get';
import { timeTrim, formatTime } from './time-helpers';
import messages from './messages';

export default function prepareProps(props, state) {
  const { onClose, node, appointmentId, mountNode, onOpen, open, intl } = props;
  const { clearLoading } = state;
  const appointmentNode = get(node, 'appointments', []).find((appointment) => (appointment.id === appointmentId));
  const highSchool = get(node, 'highSchool.name', 'Unknown School');
  const visitLocationType = get(appointmentNode, 'visitLocationType');
  const timezone = get(node, 'timezone', '');
  const startTime = get(appointmentNode, 'startISOTime');
  const endTime = get(appointmentNode, 'endISOTime');
  const timeStr = (startTime && endTime) ? timeTrim(formatTime(startTime), formatTime(endTime)) :
    intl.formatMessage(messages.unknown);
  const modalProps = { onClose, mountNode, onOpen, open, clearLoading };
  return { appointmentNode, highSchool, visitLocationType, timezone, timeStr, modalProps };
}
